// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"mv_mw","notification":"mv_mx","column":"mv_f","avatar":"mv_my","initials":"mv_mz","staff":"mv_m0","textContainer":"mv_l1","timeContainer":"mv_lq","thumbnail":"mv_m1"};